<template>
  <div class="container">
    <product-description v-if="profile.vendor && active" :product="product">
    </product-description>
    <b-alert v-if="!profile.vendor" variant="warning" show>Der <b-link to="/profile">Markenname im Profil</b-link> wird vor dem erstellen von Produkten benötigt.</b-alert>
    <div v-else-if="!active">
        <b-alert variant="warning" show>
          Dein Account muss noch vom Administrator freigeschaltet werden.
        </b-alert>
        <b-button @click="sendActivationRequest" v-if="!linkRequested">Anfrage erneut senden</b-button>
        <b-alert v-if="linkRequested" variant="success" show>
          Die Anfrage wurde gesendet.
        </b-alert>
      </div>
  </div>
</template>


<script>
import ProductDescription from "@/components/ProductDescription";
import {mapState} from "vuex";
import activationLink from "@/api/activationLink";


export default {
  computed: {
    ...mapState('user', ['profile', 'active'])
  },
  data() {
    return {
      product: {},
      vendorName: '',
      linkRequested: false
    }
  },
  components: {
    ProductDescription
  },
  methods: {
    async sendActivationRequest () {
      await activationLink.post()
      this.linkRequested = true
    }
  }
}
</script>

<style></style>
